import React, { useContext, useEffect } from 'react'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { contactAtom } from 'pages/Contacts/atoms/contactAtoms'
import { WalletActionContext } from 'pages/Wallets/context/WalletSheetProvider'
import { Contact } from 'types/contacts'
import { ChannelPaymentStep } from 'types/payments'
import { ContactsSearch } from '../../../components/Contacts/ContactsSearch'
import { channelPaymentStepAtom } from './atoms/atoms'
import { ChannelPaymentComplete } from './ChannelPaymentComplete'
import { ChannelPaymentDetails } from './ChannelPaymentDetails'

const channelPaymentSteps = [
  ChannelPaymentStep.CONTACT,
  ChannelPaymentStep.DETAILS,
  ChannelPaymentStep.COMPLETE,
] as const

export const ChannelPayment = () => {
  const { t } = useTranslation()
  const step = useAtomValue(channelPaymentStepAtom)
  const [channelPaymentStep, setChannelPaymentStep] = useAtom(channelPaymentStepAtom)
  const [walletAction, setWalletAction] = useContext(WalletActionContext)
  const setContact = useSetAtom(contactAtom)

  const isFormSteps =
    channelPaymentStep !== ChannelPaymentStep.COMPLETE &&
    channelPaymentStep !== ChannelPaymentStep.CONTACT

  const getSheetHeader = (): string => {
    switch (channelPaymentStep) {
      case ChannelPaymentStep.CONTACT:
        return t('payments.channelPayments.contactStepHeader')
      case ChannelPaymentStep.DETAILS:
        return t('payments.channelPayments.detailsStepHeader')
      default:
        return ''
    }
  }

  const handleContactSelect = (contact: Contact) => {
    setContact(contact)
    setChannelPaymentStep(ChannelPaymentStep.DETAILS)
  }

  const handleOnBack = () => {
    const currentStepIndex = channelPaymentSteps?.indexOf(channelPaymentStep)
    setChannelPaymentStep(channelPaymentSteps[currentStepIndex - 1])
    setContact(null)
  }

  useEffect(() => {
    setWalletAction({
      ...walletAction,
      header: getSheetHeader(),
      onBack: isFormSteps ? handleOnBack : null,
      meta: {
        ...walletAction?.meta,
        handleContactSelect: !walletAction?.meta?.handleContactSelect
          ? handleContactSelect
          : walletAction?.meta?.handleContactSelect,
      },
    })
  }, [channelPaymentStep])

  return (
    <Box width="full">
      {step === ChannelPaymentStep.CONTACT && <ContactsSearch />}
      {step === ChannelPaymentStep.DETAILS && <ChannelPaymentDetails />}
      {step === ChannelPaymentStep.COMPLETE && <ChannelPaymentComplete />}
    </Box>
  )
}
